<script setup>
import { useI18n } from 'vue-i18n'
import TitleComponent from "@/components/TitleComponent/index.vue"
const { t } = useI18n();
import { useRouter } from 'vue-router'
const router = useRouter()
const goBack = () => {
    router.go(-1);
}
const showIndex = ref(-1);
const changeShow = (index) => {
    if (showIndex.value == index) {
        showIndex.value = -1
    } else {
        showIndex.value = index
    }
}
const isMobile = ref(false);//false代表pc
onMounted(() => {
    isMobile.value = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    console.log('Is mobile device:', isMobile.value);
})
</script>
<template>
    <div class="container" style="padding-bottom: 50px;">
        <TitleComponent v-if="isMobile" :title="t('setup133')"></TitleComponent>

        <div class="packContent">
            <div class="title">
                {{ $t('setup133') }}
            </div>

            <div class="Headline">{{ $t('setup145') }}</div>
            <div class="Subtitle">{{ $t('setup146') }}</div>
            <div class="content" @click="changeShow(1)">
                <div class="Subtitle-title">
                    <div class="icon" :class="showIndex == 1 ? 'show-icon' : ''"><svg-icon icon-class="Down" /></div>
                    <div>{{ $t('setup147') }}</div>
                </div>
            </div>
            <div class="content" v-if="showIndex == 1">
                <p class="Subtitle-content">{{ $t('setup148') }}</p>
            </div>
            <div class="content" @click="changeShow(2)">
                <div class="Subtitle-title">
                    <div class="icon" :class="showIndex == 2 ? 'show-icon' : ''"><svg-icon icon-class="Down" /></div>
                    <div>{{ $t('setup149') }}</div>
                </div>
            </div>
            <div v-if="showIndex == 2">
                <p class="Subtitle-content">{{ $t('setup150') }}</p>
                <p class="Subtitle-content">{{ $t('setup151') }}</p>
                <p class="Subtitle-content">{{ $t('setup152') }}</p>
                <p class="Subtitle-content">{{ $t('setup153') }}</p>
                <p class="Subtitle-content">{{ $t('setup154') }}</p>
                <p class="Subtitle-content">{{ $t('setup155') }}</p>
                <p class="Subtitle-content">{{ $t('setup156') }}</p>
            </div>
            <div class="content" @click="changeShow(3)">
                <div class="Subtitle-title">
                    <div class="icon" :class="showIndex == 3 ? 'show-icon' : ''"><svg-icon icon-class="Down" /></div>
                    <div>{{ $t('setup157') }}</div>
                </div>
            </div>
            <div v-if="showIndex == 3">
                <p class="Subtitle-content">{{ $t('setup158') }}</p>
                <p class="Subtitle-content">{{ $t('setup159') }}</p>
                <p class="Subtitle-content">{{ $t('setup160') }}</p>
            </div>
            <div class="content" @click="changeShow(4)">
                <div class="Subtitle-title">
                    <div class="icon" :class="showIndex == 4 ? 'show-icon' : ''"><svg-icon icon-class="Down" /></div>
                    <div>{{ $t('setup161') }}</div>
                </div>
            </div>
            <div v-if="showIndex == 4" @click="changeShow(4)">
                <p class="Subtitle-content">{{ $t('setup162') }}</p>
                <p class="Subtitle-content">{{ $t('setup163') }}</p>
                <p class="Subtitle-content">{{ $t('setup164') }}</p>
                <p class="Subtitle-content">{{ $t('setup165') }}</p>
                <p class="Subtitle-content">{{ $t('setup166') }}</p>
                <p class="Subtitle-content">{{ $t('setup167') }}</p>
                <p class="Subtitle-content">{{ $t('setup168') }}</p>
                <p class="Subtitle-content">{{ $t('setup169') }}</p>
                <p class="Subtitle-content">{{ $t('setup170') }}</p>
            </div>
            <div class="content" @click="changeShow(5)">
                <div class="Subtitle-title">
                    <div class="icon" :class="showIndex == 5 ? 'show-icon' : ''"><svg-icon icon-class="Down" /></div>
                    <div>{{ $t('setup171') }}</div>
                </div>
            </div>
            <div v-if="showIndex == 5">
                <p class="Subtitle-content">{{ $t('setup172') }}</p>
                <p class="Subtitle-content">{{ $t('setup173') }}</p>
                <p class="Subtitle-content">{{ $t('setup174') }}</p>
                <p class="Subtitle-content">{{ $t('setup175') }}</p>
                <p class="Subtitle-content">{{ $t('setup176') }}</p>
                <p class="Subtitle-content">{{ $t('setup177') }}</p>
            </div>
            <div class="content" @click="changeShow(6)">
                <div class="Subtitle-title">
                    <div class="icon" :class="showIndex == 6 ? 'show-icon' : ''"><svg-icon icon-class="Down" /></div>
                    <div>{{ $t('setup621') }}</div>
                </div>
            </div>
            <div v-if="showIndex == 6">
                <p class="Subtitle-content">{{ $t('setup622') }}</p>
                <p class="Subtitle-content">{{ $t('setup623') }}</p>
                <p class="Subtitle-content">{{ $t('setup624') }}</p>
                <p class="Subtitle-content">{{ $t('setup625') }}</p>
                <p class="Subtitle-content">{{ $t('setup626') }}：{{ $t('setup629') }}</p>
                <p class="Subtitle-content">{{ $t('setup627') }}：<span @click="router.push('/estimation')" style="color: #ec4634;">{{ $t('setup480') }}</span></p>
            </div>
            
        </div>
    </div>
</template>
<style scoped lang='scss'>
.container {
    width: 100%;
}

.title {
    // padding-top: 40px;
    color: #282828;
    font-weight: 700;
    font-size: 25px;
    padding-bottom: 16px;
}

.Headline {
    padding: 8px 0px;
    font-size: 18px;
    line-height: 30px;
    color: #131926;
    font-family: Montserrat, Arial, sans-serif;
}

.Subtitle {
    font-size: 14px;
    line-height: 30px;
    color: #131926;
    font-family: Montserrat, Arial, sans-serif;
    padding-bottom: 15px;
}

.content {
    padding: 15px 0;



    .Subtitle-title {
        font-weight: 700;
        font-size: 14px;
        line-height: 30px;
        overflow: hidden;
        color: #131926;
        font-family: Montserrat, Arial, sans-serif;
        display: flex;
        align-items: flex-start;

        .icon {
            transform: rotate(-90deg);
            margin-right: 5px;
        }

        .show-icon {
            transform: rotate(0deg);
        }

        >div:last-child {
            width: calc(100% - 25px);
        }
    }

    .Subtitle-content {
        font-size: 14px;
        line-height: 30px;
        overflow: hidden;
        color: #131926;
        font-family: Montserrat, Arial, sans-serif;
    }
}

.sel-content {
    background-color: #F3F7F9;
}

@media (max-width: 768px) {
    .container {
        width: 100%;
    }

    .content {
        padding-top: 0px;
    }

    .packContent {
        padding: 45px 20px 100px 20px;
        .title{
            display: none;
        }
    }

   

}
</style>